import React from 'react';
import { CollapseFilterWrapper } from '../../../components/sidebar-filters/CollapseFilterWrapper';
import { NominationStatusFilterSelect } from '../../../components/sidebar-filters/filter-select/NominationStatusFilterSelect';
import { ProgramFilterSelect } from '../../../components/sidebar-filters/filter-select/ProgramFilterSelect';
import { UserFilterSelect } from '../../../components/sidebar-filters/filter-select/UserFilterSelect';
import { useSidebarFilterOptionsContext } from '../../energyUsageData/sidebar/context/SidebarFilterOptionsContext';
import { useReadinessTrackingSidebarFiltersContext } from './ReadinessTrackingSidebarFiltersContext';

export const ReadinessTrackingFilterKeys = {
    // Filters
    programId: 'programId',
    userId: 'userId',
    status: 'status',

    dateToSendEmail: 'dateToSendEmail',
    emailOpened: 'emailOpened',
} as const;

export type TReadinessTrackingFilterKey = (typeof ReadinessTrackingFilterKeys)[keyof typeof ReadinessTrackingFilterKeys];

export const ReadinessTrackingFilterLabels = {
    [ReadinessTrackingFilterKeys.programId]: 'Programs',
    [ReadinessTrackingFilterKeys.userId]: 'Users',
    [ReadinessTrackingFilterKeys.status]: 'Status',

    [ReadinessTrackingFilterKeys.dateToSendEmail]: 'Sent',
    [ReadinessTrackingFilterKeys.emailOpened]: 'Opened',
} as const;

interface IReadinessTrackingSidebarFiltersProps {
    onFilterChange: (filters: any) => void;
}

export const ReadinessTrackingSidebarFilters: React.FC<IReadinessTrackingSidebarFiltersProps> = ({ onFilterChange }) => {
    const { filters, handleFilterChange } = useReadinessTrackingSidebarFiltersContext();
    const { programOptions, userOptions, nominationReadinessTrackingStatusOptions, isLoading: isFiltersLoading } = useSidebarFilterOptionsContext();

    const handleReadinessTrackingFilterChange = (key: string, value: unknown) => {
        handleFilterChange(key, value);
        onFilterChange({ ...filters, [key]: value });
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', overflowY: 'auto' }}>
            {/* Filters */}
            <CollapseFilterWrapper label="Filters">
                <ProgramFilterSelect
                    label={ReadinessTrackingFilterLabels[ReadinessTrackingFilterKeys.programId]}
                    value={filters[ReadinessTrackingFilterKeys.programId] || []}
                    onChange={value => handleReadinessTrackingFilterChange(ReadinessTrackingFilterKeys.programId, value)}
                    options={programOptions}
                    isLoading={isFiltersLoading}
                />
                <UserFilterSelect
                    label={ReadinessTrackingFilterLabels[ReadinessTrackingFilterKeys.userId]}
                    value={filters[ReadinessTrackingFilterKeys.userId] || []}
                    onChange={value => handleReadinessTrackingFilterChange(ReadinessTrackingFilterKeys.userId, value)}
                    options={userOptions}
                    isLoading={isFiltersLoading}
                />
                <NominationStatusFilterSelect
                    label={ReadinessTrackingFilterLabels[ReadinessTrackingFilterKeys.status]}
                    value={filters[ReadinessTrackingFilterKeys.status] || []}
                    onChange={value => handleReadinessTrackingFilterChange(ReadinessTrackingFilterKeys.status, value)}
                    options={nominationReadinessTrackingStatusOptions}
                />
            </CollapseFilterWrapper>
        </div>
    );
};
